import { memo, useCallback, useEffect, useRef, useState } from "react";
import {
  Card,
  CardContent,
  TextField,
  Typography,
  Grid,
  Box,
  Button,
  IconButton,
  Avatar,
  CardMedia,
  Modal,
} from "@mui/material";
import { useLocation, useParams } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { useTMutation } from "../../../../../utils/useTMutation";
import showToast from "../../../../../components/Hot-Toast/showToast";
import CropperModal from "../../../../../components/Cropper/CropperModal";
import IMG from "../../../../../assets/images/big/profilebgimage.png";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import { API_URL } from "../../../../../appConstants";
import { nextStep, update } from "../../../../../slice/multiStepSlice";

import getCroppedImg from "../../../../../components/Cropper/cropImage";
import Cropper from "react-easy-crop";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
// import { useSelector, useDispatch } from "react-redux";
import { setSelectedTabData } from "../../../../../slice/profileTabSectionSlice";

export const jobRoleSchema = z.object({
  SPECIALTY_NAME: z.string().min(1, { message: "Job Role is required" }),
  // FILE: z
  //     .any()
  //     .refine((file) => {
  //         return file instanceof Blob || file !== "";
  //     }, { message: "File is required and must be an image" })
  //     .refine((file) => {
  //         return file !== "" ? true : file.size <= 5 * 1024 * 1024
  //     }, {
  //         message: "File size must be less than 5MB",
  //     })
  //     .refine((file) => {
  //         return file !== "" ? true : ['image/jpeg', 'image/png'].includes(file.type)
  //     }
  //         , {
  //             message: "Only JPEG and PNG files are allowed",
  //         }),
});
const AddSpecialty = ({ data }) => {
  const dispatch = useDispatch();
  const { values } = useSelector((state) => state?.multiStep);
  console.log("values", values);
  const inputRef = useRef(null);
  // const [src, setSrc] = useState(null);
  // const [preview, setPreview] = useState(null);
  // const [modalOpen, setModalOpen] = useState(false);
  // const [profileImageUrl, setProfileImageUrl] = useState(null);

  const [image, setImage] = useState(null); // Stores the final cropped image
  const { selectedTabData } = useSelector((state) => state.profileTabSection);

  // ==============For Crop Image Start==============
  const [file, setFile] = useState();
  const [cropImage, setCropImage] = useState(null);
  const [actualFile, setActualFile] = useState();
  const [openCropImageModal, setOpenCropImageModal] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [dynamicAspect, setDynamicAspect] = useState(1 / 1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  // useEffect(() => {
  //     if (values?.IMAGE_NAME) {
  //         setProfileImageUrl(API_URL + "user/viewFile?fileName=" + values?.IMAGE_NAME);

  //     }
  // }, [values?.IMAGE_NAME]);
  // const handleInputClick = (e) => {
  //     e.preventDefault();
  //     inputRef.current.click();
  // };
  // const handleImgChange = (e) => {
  //     const file = e.target.files[0];
  //     if (file && file.size < 5 * 1024 * 1024) {
  //         setSrc(URL.createObjectURL(file));
  //         setModalOpen(true);
  //     } else {
  //         alert("Please select an image smaller than 5MB.");
  //     }
  // };

  // const handleCancel = (event, reason) => {
  //     if (reason && reason === 'backdropClick') return;
  //     setModalOpen(false);  // Close modal without changing the avatar
  // };
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(jobRoleSchema),
    defaultValues: {
      SPECIALTY_NAME: values.SPECIALTY_NAME ? values.SPECIALTY_NAME : "",
      FILE: values?.IMAGE_NAME ? values?.IMAGE_NAME : "",
    },
  });
  const { mutateAsync } = useTMutation(
    "/addUpdateSpecialty",
    "post",
    (response) => {
      if (response.STATUS) {
        return response;
      }
    },
  );

  useEffect(() => {
    if (values) {
      if (values?.IMAGE_NAME) {
        setImage(API_URL + "user/viewFile?fileName=" + values?.IMAGE_NAME);
      }
    }
  }, [values?.IMAGE_NAME]);

  const submitAddJobRole = async (data) => {
    console.log("data", data);
    try {
      const formData = new FormData();
      if (typeof cropImage === "object") {
        formData.append("file", cropImage);
      }
      formData.append("SPECIALTY_NAME", data?.SPECIALTY_NAME);

      if (values?.ID) {
        formData.append("ID", values?.ID);
      }

      const response = await mutateAsync(formData);

      if (response.STATUS) {
        // ✅ Update multiStep slice as before
        dispatch(
          update(
            values?.ID
              ? response.OUTPUT?.IMAGE_NAME
                ? { ...data, IMAGE_NAME: response.OUTPUT?.IMAGE_NAME }
                : data
              : response.OUTPUT,
          ),
        );

        // ✅ Update selectedTabData in Redux to retain + reflect specialties immediately
        const existingSpecialties = selectedTabData?.specialties || [];

        if (values?.ID) {
          // Edit mode - replace only the updated specialty
          const updatedSpecialties = existingSpecialties.map((s) =>
            s.ID === values.ID ? { ...s, ...response.OUTPUT } : s,
          );
          dispatch(
            setSelectedTabData({
              ...selectedTabData,
              specialties: updatedSpecialties,
            }),
          );
        } else {
          // Add mode - append new specialty to existing list
          dispatch(
            setSelectedTabData({
              ...selectedTabData,
              specialties: [...existingSpecialties, response.OUTPUT],
            }),
          );
        }

        dispatch(nextStep());
      } else {
        showToast("error", data.MESSAGE, 3000);
      }
    } catch (error) {
      console.error("Add Request failed:", error);
      showToast("error", "Something went wrong, Please try again", 3000);
    }
  };
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    console.log("file", file);

    if (file) {
      setFile(URL.createObjectURL(e.target.files[0]));
      setActualFile(e.target.files[0]);
      setOpenCropImageModal(true);
      setCropImage(null);
    }
  };

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);
  const handleCropCancel = async () => {
    setOpenCropImageModal(false);
    // setFile();
    // setActualFile();
    // setFileName('');
    // setDynamicAspect(1 / 1);
  };

  const saveCropedImage = useCallback(async () => {
    try {
      if (!croppedAreaPixels || !file) return;

      // Get cropped image as a Blob URL
      const croppedImageUrl = await getCroppedImg(file, croppedAreaPixels);
      console.log("Cropped Image URL:", croppedImageUrl);

      // Convert Blob URL to File
      const blob = await fetch(croppedImageUrl).then((r) => r.blob());
      const myFile = new File([blob], actualFile?.name || "cropped-image.png", {
        type: "image/png",
      });
      console.log("myFile", myFile);
      // Set states correctly
      setCropImage(myFile);
      setImage(croppedImageUrl); // Update the preview image
      setOpenCropImageModal(false);
    } catch (e) {
      console.error("Error cropping image:", e);
    }
  }, [croppedAreaPixels, file, actualFile]);

  return (
    <>
      <Grid lg={12}>
        <CardContent className="gridcardcontent gridtextdata">
          <Typography variant="h2" component="div" mt={-0.5} fontWeight="bold">
            {/* Create Speciality */}
            {values?.ID ? "Edit Speciality" : "Create Speciality"}
          </Typography>
          <form onSubmit={handleSubmit(submitAddJobRole)}>
            {/* <div style={{ position: 'relative', right: 3 }}>
                            <Avatar
                                src={preview || profileImageUrl}
                                modalOpen={modalOpen}
                                setPreview={setPreview}
                                setModalOpen={setModalOpen}

                                sx={{

                                    borderRadius: 0,
                                    width: 120,
                                    height: 120,
                                    border: '3px solid white'
                                }}
                            />
                            <CameraAltOutlinedIcon
                                sx={{
                                    position: 'relative',
                                    top: -30,
                                    left: 95,
                                    padding: .5,
                                    height: 24,
                                    width: 24,
                                    backgroundColor: 'white',
                                    borderRadius: '50%',
                                    color: '#6ebe44',
                                    cursor: 'pointer'
                                }}
                                onClick={handleInputClick}
                            />
                            {errors?.FILE &&
                                <Typography color="error" variant="body2" mt={1}>
                                    {errors?.FILE?.message}
                                </Typography>
                            }
                            <input
                                type="file"
                                accept="image/*"
                                ref={inputRef}
                                onChange={handleImgChange}
                                hidden
                            />

                            Ends of Profile Picture
                        </div> */}
            <Box
              position="relative"
              my={2}
              sx={{
                width: "120px",
                height: "120px",
                backgroundColor: "#f0f0f0",
              }}
            >
              <CardMedia
                component="img"
                image={image || values?.IMAGE_NAME}
                alt=" Image"
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: image ? "cover" : "contain",
                  backgroundColor: image ? "transparent" : "#e0e0e0",
                }}
                // sx={{
                //     position: 'relative',
                //     top: -30,
                //     left: 95,
                //     padding: .5,
                //     height: 24,
                //     width: 24,
                //     // backgroundColor: 'white',
                //     borderRadius: '50%',
                //     color: '#6ebe44',
                //     cursor: 'pointer',
                //     objectFit: image ? "cover" : "contain",
                //     backgroundColor: image ? "transparent" : "#e0e0e0",
                // }}
              />

              {/* Camera Icon inside Image */}
              <IconButton
                component="label"
                sx={{
                  position: "absolute",
                  bottom: 10, // Adjust position inside the image
                  right: 10, // Adjust position inside the image
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  boxShadow: 1,
                }}
              >
                <CameraAltIcon fontSize="small" />
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={handleImageUpload}
                />
              </IconButton>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <TextField
                label="Speciality Name"
                variant="outlined"
                fullWidth
                inputProps={{ maxLength: 20 }}
                margin="normal"
                autoFocus={true}
                // InputProps={{ style: { height: '50px' } }}
                sx={{
                  "& .MuiOutlinedInput-input": {
                    padding: 1.9,
                  },
                  "& .MuiFormHelperText-root": {
                    marginLeft: 0,
                    marginTop: "4px",
                  },
                }}
                {...register("SPECIALTY_NAME")}
                error={!!errors.SPECIALTY_NAME}
                helperText={errors.SPECIALTY_NAME?.message}
              />
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  // variant="contained" sx={{ backgroundColor: '#6ebe44' }}
                  className="gradientAdminThemeColor"
                  type="submit"
                >
                  Next
                </Button>
              </Box>
            </Box>
            {/* {modalOpen && <CropperModal
                            src={src}
                            modalOpen={modalOpen}
                            setModalOpen={setModalOpen}
                            setPreview={setPreview}
                            handleCancel={handleCancel}
                            propsData="profileImage"
                            onChange={(val) => { setValue("FILE", val); console.log("FILE", val) }}
                        />} */}
            {openCropImageModal && (
              <Modal
                open={openCropImageModal}
                onClose={handleCropCancel}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Grid
                  container
                  className="crop-image-wrapper"
                  id="modal-modal-title"
                  style={{
                    width: "90vw",
                    height: "90vh",
                    maxWidth: "800px",
                    maxHeight: "600px",
                    backgroundColor: "#000",
                    padding: "20px",
                    borderRadius: "10px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {/* Image Cropper */}
                  <Grid
                    item
                    style={{
                      width: "100%",
                      height: "80%",
                      position: "relative",
                    }}
                  >
                    <Cropper
                      image={file}
                      crop={crop}
                      zoom={zoom}
                      aspect={dynamicAspect}
                      onCropChange={setCrop}
                      onCropComplete={onCropComplete}
                      onZoomChange={setZoom}
                      style={{ width: "100%", height: "100%" }}
                    />
                  </Grid>

                  {/* Controls */}
                  <Grid
                    container
                    spacing={2}
                    className="crop-control"
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "20px",
                    }}
                  >
                    <Grid item>
                      <Typography style={{ color: "white", fontSize: "12px" }}>
                        Aspect Ratio
                      </Typography>
                      <select
                        onChange={(e) =>
                          setDynamicAspect(parseFloat(e.target.value))
                        }
                        style={{ marginLeft: "10px" }}
                      >
                        <option>1/1</option>
                        <option value="1.23">1.23/1</option>
                        <option value="1.33">1.33/1</option>
                        <option value="1.43">1.43/1</option>
                        <option value="1.625">1.66/1</option>
                        <option value="2">4/2</option>
                        <option value="1.7">16/9</option>
                      </select>
                    </Grid>
                    <Grid item>
                      <Typography
                        style={{
                          color: "white",
                          fontSize: "12px",
                          textAlign: "center",
                        }}
                      >
                        Zoom
                      </Typography>
                      <input
                        type="range"
                        value={zoom}
                        min={1}
                        max={11}
                        step={0.1}
                        onChange={(e) => setZoom(e.target.value)}
                      />
                    </Grid>
                    <Grid item>
                      <Button
                        style={{ backgroundColor: "green", color: "white" }}
                        onClick={saveCropedImage}
                      >
                        Crop
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        style={{ backgroundColor: "red", color: "white" }}
                        onClick={handleCropCancel}
                      >
                        Close
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Modal>
            )}
          </form>
        </CardContent>
      </Grid>
    </>
  );
};

export default memo(AddSpecialty);
